import request from "@/utils/request";

// 列表(主数据列表)
export function loadOutdepotBillListDataApi(data) {
  return request({
    url: "web/outdepotBill/listData",
    method: "post",
    data
  });
}
// 导出
export function loadOutdepotBillExportDataApi(data) {
  return request({
    url: "web/outdepotBill/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateOutdepotBillApi(data) {
  return request({
    url: "web/outdepotBill/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initOutdepotBillApi(data) {
  return request({
    url: "web/outdepotBill/initOutdepotBill",
    method: "post",
    data
  });
}

// 出库明细分页查询
export function loadOutdepotBillDetailListDataApi(data) {
  return request({
    url: "web/outdepotBillDetail/listData",
    method: "post",
    data
  });
}
// 出库明细导出
export function loadOutdepotBillDetailExportDataApi(data) {
  return request({
    url: "web/outdepotBillDetail/exportData",
    method: "post",
    data
  });
}
// 根据出库单id初始化物料明细
export function initOutdepotBillDetailApi(data) {
  return request({
    url: "web/outdepotBillDetail/initOutdepotBillDetail",
    method: "post",
    data
  });
}
// 根据条件获取出库单物料明细
export function findOutdepotBillDetailByConditionApi(data) {
  return request({
    url: "web/outdepotBillDetail/findOutdepotBillDetailByCondition",
    method: "post",
    data
  });
}
// 根据条件分页查询
export function findOutdepotBillDetailListDataPageByConditionApi(data) {
  return request({
    url: "web/outdepotBillDetail/findListDataPageByCondition",
    method: "post",
    data
  });
}
// 根据条件分页查询统计
export function findOutdepotBillDetailListDataPageByStatisticsApi(data) {
  return request({
    url: "web/outdepotBillDetail/findListDataPageByStatistics",
    method: "post",
    data
  });
}
// 导出统计
export function exportOutdepotBillDetailListDataPageByStatisticsApi(data) {
  return request({
    url: "web/outdepotBillDetail/exportListDataPageByStatistics",
    method: "post",
    data
  });
}
// 根据条件分页查询物料领用使用统计
export function findOutdepotBillDetailListDataPageBySchemeStatisticsApi(data) {
  return request({
    url: "web/outdepotBillDetail/findListDataPageBySchemeStatistics",
    method: "post",
    data
  });
}
// 物料领用使用统计导出统计
export function exportOutdepotBillDetailListDataPageBySchemeStatisticsApi(
  data
) {
  return request({
    url: "web/outdepotBillDetail/exportListDataPageBySchemeStatistics",
    method: "post",
    data
  });
}
// 根据条件分页查询物料明细使用统计
export function findOutdepotBillDetailListDataPageByUsedStatisticsApi(data) {
  return request({
    url: "web/outdepotBillDetail/findListDataPageByUsedStatistics",
    method: "post",
    data
  });
}
// 根据条件查询物料使用明细统计明细数据
export function findOutdepotBillDetailListDataByStatisticsItemApi(data) {
  return request({
    url: "web/outdepotBillDetail/findListDataByStatisticsItem",
    method: "post",
    data
  });
}
// 根据条件导出物料使用明细统计明细数据
export function exportOutdepotBillDetailListDataByStatisticsItemApi(data) {
  return request({
    url: "web/outdepotBillDetail/exportListDataByStatisticsItem",
    method: "post",
    data
  });
}

// 获取待入库的调拨物料数量
export function countTransferTodoInApi(data) {
  return request({
    url: "web/outdepotBillDetail/countTransferTodoIn",
    method: "post",
    data
  });
}
// 待处理出库物料分页查询
export function loadOutdepotBillListTodoDataApi(data) {
  return request({
    url: "web/outdepotBillDetail/listTodoData",
    method: "post",
    data
  });
}
// 根据方案ID查询物料使用统计
export function findOutdepotBillDetailListStatisticsBySchemeIdApi(data) {
  return request({
    url: "web/outdepotBillDetail/findListDataStatisticsBySchemeId",
    method: "post",
    data
  });
}